define('modules/reporting/segments/dataExport/createEdit/overlap/main',["jQuery", "T1", "T1Module"], function ($, T1, T1Module) {
  "use strict";

  return new T1Module({
    defaultView: "overlap",
    name: "reporting/segments/dataExport/createEdit/overlap",
    viewCfgs: {
      list: {},
      bins: {}
    }
  });
});
